import { useField } from "formik";
import { useMemo } from "react";
import { TransferRuleDirection } from "@common/types/transactionRule";
import { useEntities } from "@hooks/useEntities";
import {
    TransactionRuleActionFormSchema,
    TransactionRuleConditionFormSchema,
} from "./constants";
import {
    resolveAccountTargetEntities,
    resolveEntitiesForConditionScope,
} from "./entityScope";

interface UseEntitiesFromFormConditionOptions {
    transferDirection?: TransferRuleDirection;
    scopedEntityIds?: number[];
}

export function useEntitiesFromFormCondition({
    transferDirection,
    scopedEntityIds,
}: UseEntitiesFromFormConditionOptions = {}) {
    const entities = useEntities();
    const fieldName = transferDirection
        ? `conditions.${transferDirection}`
        : "conditions";
    const [conditionsField] =
        useField<TransactionRuleConditionFormSchema[]>(fieldName);
    const conditionsValue = conditionsField.value;

    return useMemo(
        () =>
            resolveEntitiesForConditionScope({
                entities,
                conditions: conditionsValue ?? [],
                scopedEntityIds,
            }),
        [entities, conditionsValue, scopedEntityIds],
    );
}

export function useAccountTargetEntities({
    scopedEntityIds,
}: {
    scopedEntityIds?: number[];
}) {
    const entities = useEntities();
    const [conditionsField] =
        useField<TransactionRuleConditionFormSchema[]>("conditions");
    const [actionsField] =
        useField<TransactionRuleActionFormSchema[]>("actions");
    const conditionsValue = conditionsField.value;
    const actionsValue = actionsField.value;

    return useMemo(
        () =>
            resolveAccountTargetEntities({
                entities,
                conditions: conditionsValue ?? [],
                actions: actionsValue ?? [],
                scopedEntityIds,
            }),
        [entities, conditionsValue, actionsValue, scopedEntityIds],
    );
}
